// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-now {
  font-weight: bold;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/breadcrumb/breadcrumb.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,0BAAA;AACJ","sourcesContent":[".action-now {\n    font-weight: bold;\n    text-decoration: underline;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
